import { render } from "./UploadPicture.vue?vue&type=template&id=3f575c1d&scoped=true&ts=true"
import script from "./UploadPicture.vue?vue&type=script&lang=ts"
export * from "./UploadPicture.vue?vue&type=script&lang=ts"

import "./UploadPicture.vue?vue&type=style&index=0&id=3f575c1d&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src129899678/src/web-ext-ai-voucher-humelo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f575c1d"]])

export default __exports__